// extracted by mini-css-extract-plugin
export default {"top":"CartProducts_top__jlOrY","selectAllLabel":"CartProducts_selectAllLabel__+Y59W","list":"CartProducts_list__HrNfW","product":"CartProducts_product__KflTE"};